import React from "react";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "@/hooks/useScrollAnimation";
import "./AboutUsSection.scss";

const AboutUsSection: React.FC = () => {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const stats: { num: string | null; key: string; display?: React.ReactNode }[] = [
    { num: "20+", key: "projectsDelivered" },
    { num: "15+", key: "yearsInSoftware" },
    { num: null, key: "approach", display: <>AI<em>-first</em></> },
    { num: "A+", key: "grade" },
  ];

  return (
    <section className="about-section" ref={ref}>
      <div id="about-section" className="container">
        <div className="about-grid">
          <div className={`reveal${isVisible ? " in" : ""}`}>
            <span className="sec-label">{t("about.label")}</span>
            <h2 className="sec-title">
              {(() => {
                const title = t("about.title");
                const hl = t("about.titleHighlight");
                const [before, after = ""] = title.split(hl);
                return <>{before}<em>{hl}</em>{after}</>;
              })()}
            </h2>
          </div>
          <div className={`about-copy reveal${isVisible ? " in" : ""}`} style={{ transitionDelay: "0.1s" }}>
            <p>{t("about.desc1")}</p>
            <p>{t("about.desc2")}</p>
            <div className="stat-grid">
              {stats.map((s, i) => (
                <div className="stat" key={i}>
                  <div className="stat-num">
                    {s.display ?? s.num}
                  </div>
                  <div className="stat-label">{t(`about.stats.${s.key}`)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
